export default function EtatReglementsConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('etat.reglements');
}

EtatReglementsConfiguration.$inject = ['$translatePartialLoaderProvider'];
